import React from 'react';
import { MdSecurity, MdLock } from 'react-icons/md';
import { Divider } from 'antd';
import { Auth } from '@whatsper/texterchat-common';
import Collapsable from './Collapsable';
import { useStore } from '../../../../store/rootStore';
import s from './Collapsable/Collapsable.module.scss';
const SecuritySettings = ({ goToAppPath }) => {
    const { loginStore } = useStore();
    const allRoutes = [
        {
            titleKey: 'totpSetupTitle',
            icon: React.createElement(MdLock, null),
            path: '/manage/security/totp-setup',
            condition: () => { var _a; return !!((_a = loginStore.availableAuthMethods) === null || _a === void 0 ? void 0 : _a.includes(Auth.Methods.Method.totp)); },
        },
    ];
    const routes = allRoutes.filter(route => !route.condition || route.condition());
    if (routes.length === 0) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Divider, { className: s.divider }),
        React.createElement(Collapsable, { title: "securitySettings", icon: React.createElement(MdSecurity, null), routes: routes, goToAppPath: goToAppPath })));
};
export default SecuritySettings;
